'use strict';

/**
 * Collection for contacts
 *
 * @category   Collection
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Collection = require('base/Colido.Collection');
var ContactModel = require('../models/contact');

var ContactsCollection = Collection.extend({
    api: '/community/contacts',

    name: 'community:contacts',

    model: ContactModel,

    sortDefault: 'name.asc',

    sortFieldsMap: {
        'name': 'properName',
        // 'locality.asc': 'locality.asc-name.asc',
        // 'locality.desc': 'locality.desc-name.desc',
        // 'dimensions': 'volume',
        // 'dimensionsType': 'dimensionsTypeAsNumber',
        // 'weight': 'normalizedWeight',
        // 'lastEdited': 'modifiedTime',
        // 'location': 'storage',
    },

    initialize: function() {
        this.applyPatchExtension();

        this.on('destroy', function(contact) {
            App.radio('community').trigger('contact:destroy', contact);
        });

        this.listenTo(App.radio(this.name).vent, 'updated', function(data) {
            this.setFromWebsocket(data, {remove: false});
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'removed', function(data) {
            this.remove(data); //data [1,2,3]
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'added', function(data) {
            this.add(data);
        }.bind(this));
    },

    /**
     * Override default comparator to order by id, when default comparison is equal
     * @param {Backbone.Model} a Model a
     * @param {Backbone.Model} b Model b
     * @returns {integer}
     */
    comparator: function(a, b) {
        var compare = Collection.prototype.comparator.call(this, a, b);

        if (compare === 0) {
            return parseInt(a.get('id')) < parseInt(b.get('id')) ? -1 : 1;
        } else {
            return compare;
        }
    },

    getByUserId: function(userId) {
        return this.findWhere({userId: userId});
    },
});

module.exports = ContactsCollection;